import React, { memo } from 'react';
import { ArrowForward } from '@yme/assets/icons';
import { Button, CONTAINED_VARIANT, SIZE_44, TRAILING_ICON } from '@yme/atoms/button';
import { Col, Row } from '@yme/atoms/grid';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { HeadingLevel3, RegularTextLevel4 } from '@yme/tokens/typography';
import { ContainerStyled, FlexWrapperContainer, ForwardButtonContainerStyled, ReimbursementWrapperStyled, } from './StickyNavBarStyled';
export const StickyNavBar = memo(({ isNextDisabled, isLoading = false, reimbursement }) => {
    const { t } = useTranslation();
    const { isMobileView } = useWindowSize();
    return (React.createElement(ContainerStyled, { width: "100%" },
        React.createElement(Row, { justifyContent: "center" },
            React.createElement(Col, { lg: 8 },
                React.createElement(FlexWrapperContainer, { justifyContent: "space-between", isMobileView: isMobileView },
                    React.createElement(ForwardButtonContainerStyled, null,
                        React.createElement(ReimbursementWrapperStyled, null,
                            React.createElement(RegularTextLevel4, { color: colorCoreBlack300 }, `${t('returnForm_selectItemsTotalReimbursement_label')}:`),
                            React.createElement(HeadingLevel3, null, reimbursement)),
                        React.createElement(Button, { type: "submit", width: isMobileView ? '100%' : 'auto', size: SIZE_44, buttonVariant: CONTAINED_VARIANT, hasIconButton: TRAILING_ICON, iconRotate: false ? 180 : 0, iconComponent: ArrowForward, disabled: isNextDisabled, label: t('returnForm_continue_button'), isLoading: isLoading })))))));
});
StickyNavBar.displayName = 'ButtonsNavBar_ReturnForm';
